const UndoIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="50 50 400 400"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>undo</title>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Combined-Shape" fill="currentColor" transform="translate(55.253333, 80.915055)">
          <path d="M141.254834,192 L111.084945,222.169889 L0,111.084945 L111.084945,0 L141.254834,30.1698893 L81.642,89.794 L254.4,89.794278 C330.09408,89.794278 391.800173,150.74343 393.026725,226.150181 L393.045333,228.439611 C393.045333,304.898278 330.858667,367.084945 254.4,367.084945 L254.4,367.084945 L179.52,367.084945 L179.52,324.418278 L254.4,324.418278 C307.306667,324.418278 350.378667,281.346278 350.378667,228.439611 C350.378667,175.532945 307.306667,132.460945 254.4,132.460945 L254.4,132.460945 L81.727,132.46 L141.254834,192 Z"></path>
        </g>
      </g>
    </svg>
  )
}

export default UndoIcon
